import Vue from 'vue';
import Router from 'vue-router';
import platform from './lib/platform';
import CommonRoutes from './router/modules/common';
import FissionRoutes from './router/modules/fission';
import WelfareRoutes from './router/modules/welfare';
import OperationRoutes from './router/modules/operation';
import WeiXinRoutes from './router/modules/weixin';

Vue.use(Router);

const router = new Router({
	mode: 'history', // hash | history
	fallback: false,
	routes: [
		...CommonRoutes,
		...FissionRoutes,
		...WelfareRoutes,
		...OperationRoutes,
		...WeiXinRoutes,
		{
			path: '/task',
			name: 'new-task',
			component: (resolve) => require(['@/components/welfare/components/Task/index.vue'], resolve),
			meta: {
				prefetch: true, // 是否开启预加载
			},
		},
		{
			path: '/welfare/task',
			name: 'welfareTask',
			component: (resolve) => require(['@/components/welfare/components/Task/index.vue'], resolve),
		},
		{
			path: '/ios-task',
			name: 'ios-task',
			component: (resolve) => require(['@/components/ios-task/index'], resolve),
		},
		{
			path: '/invite_code',
			name: 'inviteCode',
			component: (resolve) => require(['@/components/inviteCode'], resolve),
		},
		{
			path: '/wallet',
			name: 'wallet',
			component: (resolve) => require(['@/components/wallet/index.vue'], resolve),
		},
		{
			path: '/withdraw',
			name: 'withdraw',
			component: (resolve) => require(['@/components/withdraw/index.vue'], resolve),
		},
		{
			path: '/new-withdraw',
			name: 'new-withdraw',
			component: (resolve) => require(['@/components/withdraw/index.vue'], resolve),
		},
		{
			path: '/withdraw_status_new',
			name: 'withdrawStatusNew',
			component: (resolve) => require(['@/components/withdraw/withdraw-status/index.vue'], resolve),
		},
		{
			path: '/withdraw_status',
			name: 'withdrawStatus',
			component: (resolve) => require(['@/components/withdrawStatus'], resolve),
		},
		{
			path: '/withdraw_card_bag',
			name: 'withdraw_card_bag',
			component: (resolve) => require(['@/components/withdraw/CardBagPage/'], resolve),
		},
		{
			path: '/withdraw_all_card_bag',
			name: 'withdraw_all_card_bag',
			component: (resolve) => require(['@/components/withdraw/CardBagPage/AllBagPage.vue'], resolve),
		},
		{
			path: '/invite_friend',
			name: 'inviteFriend',
			component: (resolve) => require(['@/components/fission-new/index.vue'], resolve),
		},
		{
			path: '/invite_friend/invite_detail',
			name: 'InviteFriendDetail',
			component: (resolve) => require(['@/components/fission-new/v1.0-8yuan/Record'], resolve),
		},
		{
			path: '/agreement',
			name: 'Agreement',
			component: (resolve) => require(['@/components/agreement'], resolve),
		},
		{
			path: '/privacy_protocol',
			name: 'PrivacyProtocol',
			component: (resolve) => require(['@/components/privacyProtocol'], resolve),
		},
		{
			path: '/privacy_protocol_v2',
			name: 'PrivacyProtocolV2',
			component: (resolve) => require(['@/components/majiaProtocol'], resolve),
		},
		{
			path: '/red_envelopes',
			name: 'RedEnvelopes',
			component: (resolve) => require(['@/components/redEnvelopes'], resolve),
		},
		// 第三方分享下载页（例如：省钱快报）
		{
			path: '/third_share',
			name: 'ThirdShare',
			component: (resolve) => require(['@/components/thirdShare'], resolve),
		},
		// 提取码
		{
			path: '/extract_intro',
			name: 'extractIntro',
			component: (resolve) => require(['./components/extractIntro.vue'], resolve),
		},
		// 话题页
		{
			path: '/topic',
			name: 'topic',
			component: (resolve) => require(['@/components/topic.vue'], resolve),
		},
		/* -----------------------------------------------------------  游戏模块开始   ----------------------------------------------------------- */
		// 睡觉任务
		{
			path: '/game/sleep',
			name: 'gameSleep',
			component: (resolve) => require(['@/components/game/sleep/index.vue'], resolve),
		},
		{
			path: '/game/walk',
			name: 'gameWalk',
			component: (resolve) => require(['@/components/game/walk/index.vue'], resolve),
		},
		{
			path: '/game/walk/detail',
			name: 'gameWalkDetail',
			component: (resolve) => require(['@/components/game/walk/detail.vue'], resolve),
		},
		/* -----------------------------------------------------------  游戏模块结束！   ----------------------------------------------------------- */

		/* -----------------------------------------------------------  活动模块开始！   ----------------------------------------------------------- */
		{
			path: '/activity/fortune_wheel_page',
			name: 'FortuneWheelPage',
			component: (resolve) => require(['@/components/activity/FortuneWheelPage'], resolve),
		},
		{
			path: '/activity/red_packet_rain',
			name: 'ActivityRedPacketRain',
			component: (resolve) => require(['@/components/red-packet-rain/index.vue'], resolve),
		},
		{
			path: '/activity/submit',
			name: 'submit',
			component: (resolve) => require(['@/components/activity/submit/Submit.vue'], resolve),
		},
		{
			path: '/template/manual',
			name: 'manual',
			component: (resolve) => require(['@/components/activity/manual/index.vue'], resolve),
		},
		{
			path: '/template/activity_template',
			name: 'activitTemplate',
			component: (resolve) => require(['@/components/activity/activity-template/index.vue'], resolve),
		},
		{
			path: '/template/activity_template_v2',
			name: 'activitTemplateV2',
			component: (resolve) => require(['@/components/activity/activity-template/index_v2.vue'], resolve),
		},
		{
			path: '/template/activity_template_v3',
			name: 'activitTemplateV3',
			component: (resolve) => require(['@/components/activity/activity-template/index_v3.vue'], resolve),
		},
		{
			path: '/template/activity_template_v3/reward',
			name: 'activitTemplateV3Reward',
			component: (resolve) => require(['@/components/activity/activity-template/MyReward.vue'], resolve),
		},
		{
			path: '/template/activity_rules',
			name: 'activitRules',
			component: (resolve) => require(['@/components/activity/activity-template/RulesDetail.vue'], resolve),
		},
		{
			path: '/template/manual_template',
			name: 'manualTemplate',
			component: (resolve) => require(['@/components/activity/manual-template/index.vue'], resolve),
		},
		{
			path: '/musician',
			name: 'musician',
			component: (resolve) => require(['@/components/musician/index.vue'], resolve),
		},
		{
			path: '/appreciate_music',
			name: 'AppreciateMusic',
			component: (resolve) => require(['@/components/appreciate-music/index'], resolve),
		},
		/* -----------------------------------------------------------  活动模块结束！   ----------------------------------------------------------- */
		/* -----------------------------------------------------------  公共模块开始！   ----------------------------------------------------------- */
		{
			path: '/share_download',
			name: 'share_download',
			component: (resolve) => require(['@/components/invite-friend/qrcode-download.vue'], resolve),
		},
		/* -----------------------------------------------------------  公共模块结束！   ----------------------------------------------------------- */

		/* -----------------------------------------------------------  公共模微信公共平台模块开始！   ----------------------------------------------------------- */
		{
			path: '/wx_withdraw',
			name: 'WxWithdraw',
			component: (resolve) => require(['@/components/wx-withdraw.vue'], resolve),
		},
		{
			path: '/wx_withdraw_record',
			name: 'WxWithdrawRecord',
			component: (resolve) => require(['@/components/wx-platform/wx-withdraw-record.vue'], resolve),
		},
		{
			path: '/wx_withdraw_status',
			name: 'WxWithdrawStatus',
			component: (resolve) => require(['@/components/wx-platform/wx-withdrawStatus.vue'], resolve),
		},
		{
			path: '/wx_withdraw_coin_cash',
			name: 'WxWithdrawCoinCash',
			component: (resolve) => require(['@/components/wx-platform/wx-withdraw-cion&cash.vue'], resolve),
		},
		/* -----------------------------------------------------------  公共模微信公共平台模块结束！  ----------------------------------------------------------- */
		{
			path: '/withdraw_records',
			name: 'withdrawRecords',
			component: (resolve) => require(['@/components/withdrawRecords.vue'], resolve),
		},
		{
			path: '/collect_task',
			name: 'collect_task',
			component: (resolve) => require(['@/components/collect-task/collect-index/index.vue'], resolve),
		},
		{
			path: '/collect_detail',
			name: 'collect_detail',
			component: (resolve) => require(['@/components/collect-task/collect-detail/index.vue'], resolve),
		},
		// fission-new/我的好友记录 && 邀请记录 路由
		{
			path: '/fission_new/record',
			name: 'fission_new_record',
			component: (resolve) => require(['@/components/fission-new/v1.0-8yuan/Record.vue'], resolve),
		},

		{
			path: '/open_red_packet',
			name: 'open_red_packet',
			component: (resolve) => require(['@/components/open-red-packet/index.vue'], resolve),
		},
		// 新用户注册流程方案 a 收到的红包页面
		{
			path: '/register_process/red_envelop',
			name: 'RedEnvelop',
			component: (resolve) => require(['@/components/register-process/RedEnvelop'], resolve),
		},
		// 新用户注册流程方案 a 提现页面
		{
			path: '/register_process/withdraw',
			name: 'RegisterWithdraw',
			component: (resolve) => require(['@/components/register-process/Withdraw'], resolve),
		},
		// 新用户注册流程方案 a 提现进度
		{
			path: '/register_process/withdraw-result',
			name: 'RegisterWithdrawResult',
			component: (resolve) => require(['@/components/register-process/WithdrawResult'], resolve),
		},
		// 提现-晒单-列表页
		{
			path: '/share-order/withdraw-list',
			name: 'WithdrawList',
			component: (resolve) => require(['@/components/withdraw/ShareOrder/WithdrawList.vue'], resolve),
		},
		// 提现-晒单-编辑页
		{
			path: '/share-order/share-edit',
			name: 'ShareEdit',
			component: (resolve) => require(['@/components/withdraw/ShareOrder/ShareEdit.vue'], resolve),
		},
		// 天天拆红包ios
		{
			path: '/open_red_packet_ios',
			name: 'open_red_packet_ios',
			component: (resolve) => require(['@/components/open-red-packet/index_ios.vue'], resolve),
		},
		// 限时任务金活动页 v2.0
		{
			path: '/limit-reward-activity',
			name: 'LimitRewardActivity',
			component: (resolve) => require(['@/components/activity/limit-reward-v2.0/index.vue'], resolve),
		},
		// 古诗词内容频道
		{
			path: '/poem-channel',
			component: (resolve) => require(['@/components/activity/poem-recitation/index.vue'], resolve),
			children: [
				{
					path: '',
					name: 'PoemChannel',
					component: (resolve) => require(['@/components/activity/poem-recitation/Poem.vue'], resolve),
				},
				{
					path: 'play-show',
					name: 'PlayShow',
					component: (resolve) => require(['@/components/activity/poem-recitation/PlayShow/index.vue'], resolve),
					meta: {
						keepAlive: true,
					},
				},
				// 古诗词内容频道
				{
					path: 'channel-list',
					name: 'PoemChannelList',
					component: (resolve) => require(['@/components/activity/poem-recitation/PoemChannel'], resolve),
					meta: {
						keepAlive: false,
					},
				},
			],
			meta: {
				keepAlive: true,
			},
		},
		// 微信实名认证
		{
			path: '/wx-real-name-auth',
			name: 'WxRealNameAuth',
			component: (resolve) => require(['@/components/withdraw/RealNameBanner'], resolve),
		},
		// 实物奖励
		{
			path: '/material_reward',
			name: 'material_reward',
			component: (resolve) => require(['@/components/material-reward/index.vue'], resolve),
			children: [
				{
					path: 'fill',
					name: 'material_reward_index',
					component: (resolve) => require(['@/components/material-reward/FillForm.vue'], resolve),
				},
				{
					path: 'confirm',
					name: 'material_reward_confirm',
					component: (resolve) => require(['@/components/material-reward/Confirm.vue'], resolve),
				},
			],
		},
		// 裂变框架 v1.3
		// 裂变体系提现页
		{
			path: '/fission-v1.3/withdraw',
			name: 'FissionWithdraw',
			component: (resolve) => require(['@/components/fission-new/V3/v3.2/Withdraw/index.vue'], resolve),
		},
		// 裂变好友页
		{
			path: '/fission-v1.3/friends',
			name: 'FissionFriends',
			component: (resolve) => require(['@/components/fission-new/V3/v3.2/Friend/index.vue'], resolve),
		},
		// 裂变框架二期 v1.3.1 主活动详情页
		{
			path: '/fission-v1.3/main-activity-detail',
			name: 'MainActivityDetail',
			component: (resolve) => require(['@/components/fission-new/V3/v3.2/Fission/MainActivityDetail.vue'], resolve),
		},
		// 裂变框架二期 v1.3.1 长期裂变活动详情页
		{
			path: '/fission-v1.3/long-activity-detail',
			name: 'LongActivityDetail',
			component: (resolve) => require(['@/components/fission-new/V3/v3.2/Fission/LongActivityDetail.vue'], resolve),
		},
		// 裂变框架二期 v1.3.1 限时任务活动详情页
		{
			path: '/fission-v1.3/limit_time_activity',
			name: 'LimitTimeActivity',
			component: (resolve) => require(['@/components/fission-new/V4/FissionV4.vue'], resolve),
		},
		{
			path: '/shopping-mall',
			name: 'mall',
			component: (resolve) => require(['@/components/mall/index.vue'], resolve),
		},
		{
			path: '/pendant-management',
			name: 'PendantManagement',
			component: (resolve) => require(['@/components/pendantManagement/index.vue'], resolve),
		},
		// 每日签到-签到详情页
		{
			path: '/sign-detail',
			name: 'SignDetail',
			component: (resolve) => require(['@/components/welfare/components/Task/SignDetail.vue'], resolve),
		},
		// 会员体系-会员主页
		{
			path: '/membership-system',
			name: 'MembershipSystem',
			component: (resolve) => require(['@/components/membership-system/index.vue'], resolve),
		},
		// 会员体系-会员协议页面
		{
			path: '/membership-agreement',
			name: 'MembershipAgreement',
			component: (resolve) => require(['@/components/membership-system/Protocol.vue'], resolve),
		},
		// 会员体系-会员协议页面
		{
			path: '/membership-deductions',
			name: 'MembershipDeductions',
			component: (resolve) => require(['@/components/membership-system/Deductions.vue'], resolve),
		},
		// 会员体系-管理续费页面
		{
			path: '/membership-renewal-management',
			name: 'MembershipRenewalManagement',
			component: (resolve) => require(['@/components/membership-system/RenewalManagement.vue'], resolve),
		},
		// 双人打卡活动页面
		{
			path: '/double-sign-in',
			name: 'DoubleSignIn',
			component: (resolve) => require(['@/components/activity/double-sign-in/index.vue'], resolve),
		},
		// ios 车载蓝牙车型列表页面
		{
			path: '/ios-bluetooth-list',
			name: 'BluetoothList',
			component: (resolve) => require(['@/components/ios-bluetooth/CarList.vue'], resolve),
		},
		// ios 车载蓝牙车型说明详情页面
		{
			path: '/ios-bluetooth-detail',
			name: 'BluetoothDetail',
			component: (resolve) => require(['@/components/ios-bluetooth/Detail.vue'], resolve),
		},
		// 砸金蛋活动页面
		{
			path: '/smashing-golden-eggs',
			name: 'SmashingGoldenEggs',
			component: (resolve) => require(['@/components/activity/smashing-golden-eggs/index.vue'], resolve),
		},
		{
			path: '/cash-tree',
			name: 'CashTree',
			component: (resolve) => require(['@/components/activity/cash-tree/index.vue'], resolve),
		},
		{
			path: '/2022-annual-report',
			name: 'AnnualReport',
			component: (resolve) => require(['@/components/activity/listen-report'], resolve),
		},
		{
			path: '/2023-annual-report',
			name: 'AnnualReport2023',
			component: (resolve) => require(['@/components/activity/listen-report2023'], resolve),
		},
		{
			path: '/mall-activity',
			name: 'Mall',
			component: (resolve) => require(['@/components/mall/mall-home'], resolve),
		},
		{
			path: '/mall-activity/detail',
			name: 'MallDetail',
			component: (resolve) => require(['@/components/mall/detail'], resolve),
		},
		{
			path: '/mall-activity/confirm-order',
			name: 'MallConfirmOrder',
			component: (resolve) => require(['@/components/mall/confirm-order'], resolve),
		},
		{
			path: '/growth-center',
			name: 'GrowthCenter',
			component: (resolve) => require(['@/components/GrowthCenter/index.vue'], resolve),
		},
		{
			path: '/mystery-box-center',
			name: 'MysteryBoxCenter',
			component: (resolve) => require(['@/components/activity/mystery-box-center/index.vue'], resolve),
		},
		{
			path: '/ios-payment/page1',
			name: 'IosPaymentPage1',
			component: (resolve) => require(['@/components/activity/ios-payment/page1/index.vue'], resolve),
		},
		{
			path: '/ios-payment/page2',
			name: 'IosPaymentPage2',
			component: (resolve) => require(['@/components/activity/ios-payment/page2/index.vue'], resolve),
		},
		{
			path: '/ios-payment/page3',
			name: 'IosPaymentPage3',
			component: (resolve) => require(['@/components/activity/ios-payment/page3/index.vue'], resolve),
		},
		{
			path: '/*',
			name: 'page404',
			component: (resolve) => require(['@/components/404'], resolve),
		},
	],
});

router.beforeEach((to, from, next) => {
	if (platform.platform === 'ios' && to.path === '/task') {
		next({
			name: 'ios-task',
		});
		return;
	}
	next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js